<div class="sidebar-hover-zone" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <aside class="app-sidebar" [attr.data-hkdb-theme]="hkdbTheme">
  <nav class="sidebar-nav">
    <ng-container *ngFor="let section of menuSections">
      <p class="sidebar-section">{{ section.title }}</p>
      <ul class="sidebar-menu">
        <li class="sidebar-item" *ngFor="let item of section.items">
          <a
            [routerLink]="item.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="sidebar-link"
          >
            <span class="sidebar-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-text">{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </ng-container>
  </nav>
  </aside>
</div>
